/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC } from 'react';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import { TspInfo } from '@widgets/tsp-info';
import { OldFAQ } from '@widgets/faq';
import { ReplenishmentInfo } from '@widgets/replenishment-info';
import { AccountInfo } from '@widgets/account-info';
import { PaymentInfo } from '@widgets/payment-info';
import { OldSbpQrModalDesktop } from '@widgets/sbp-qr-modal';
import { OldPaymentForm } from '@features/payment/payment-form';
import { getFaqForTspPage } from '@entities/faq';
import { ServerOption } from '@entities/server';
import { useSetBreadCrumbsCurrentPath } from '@shared/lib/breadcrumbs';
import { Partners, usePartner } from '@shared/lib/partner';
import { Spacer } from '@shared/ui/atoms';
import { Payee } from '@root/api/ump-catalog-manager';
import { FetchHintsResponseType } from '@entities/hint';
const DynamicBreadcrumbs = dynamic(() => import('@widgets/Breadcrumbs').then(imported => imported.OldBreadcrumbs), {
  loading: () => <div />,
  ssr: true
});
interface OldTspFormPageViewProps {
  h1: string;
  payee: Payee;
  linkedTsp: Payee;
  countryVouchers: {
    country: string;
    icon: string;
  }[];
  denominationsByCountry: Record<string, Payee[]>;
  providerURL: string;
  servers: ServerOption[];
  hints: FetchHintsResponseType;
}
const OldTspFormPageView: FC<OldTspFormPageViewProps> = ({
  h1,
  payee,
  linkedTsp,
  countryVouchers,
  denominationsByCountry,
  servers,
  hints
}) => {
  const {
    partner
  } = usePartner();
  useSetBreadCrumbsCurrentPath(h1);
  return <>
      {partner !== Partners.SMARTSHELL && <DynamicBreadcrumbs />}

      {/* @ts-ignore */}
      <OldPaymentForm h1={h1} payee={payee} linkedTsp={linkedTsp} countryVouchers={countryVouchers} denominationsByCountry={denominationsByCountry} servers={servers} hints={hints} renderTspInfo={props => <TspInfo {...props} />} renderReplenishmentInfo={props => <ReplenishmentInfo {...props} />} renderAccountInfo={props => <AccountInfo {...props} />} renderPaymentInfo={props => <PaymentInfo {...props} />} renderQrModal={props => <OldSbpQrModalDesktop {...props} />} />
      <Spacer space={64} spacetablet={48} spacemob={32} />
      <FAQWrapper>
        {/* @ts-ignore */}
        <OldFAQ content={getFaqForTspPage(payee, partner)} />
      </FAQWrapper>
    </>;
};
export default OldTspFormPageView;
const FAQWrapper = /*#__PURE__*/styled('div')({
  name: "FAQWrapper",
  class: "f131omoo",
  propsAsIs: false
});

require("./OldTspFormPageView.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldTspFormPageView.tsx");